import { t } from '@lingui/macro';
import { Button } from '../../../../shared/view/components/Button/Button';
import { SyringeIcon } from '../../../../shared/view/icons/Syringe.icon';
import { InjectionCountDropdown } from './InjectionCountDropdown';

export type InjectionCountInputViewProps = {
  selected: number | null;
  onSelectedChange: (value: number) => void;
  onSubmit: () => void;
};

export const InjectionCountInputView = ({
  selected,
  onSelectedChange,
  onSubmit,
}: InjectionCountInputViewProps) => (
  <div className="flex flex-col flex-grow w-full">
    <h1 className="font-sans-ext text-grey-0 text-title-l font-semibold pb-16 leading-tight">
      {t`checkin.injection-count.input.title`}
    </h1>

    <div className="flex items-center gap-12 pb-24 max-w-[75%]">
      <span className="flex items-center justify-center w-40 h-40 rounded-full bg-grey-800 text-grey-0 shrink-0">
        <SyringeIcon />
      </span>
      <p className="text-grey-300 text-p2 flex-1">
        {t`checkin.injection-count.input.hint`}
      </p>
    </div>

    <div className="bg-grey-800 rounded-xl p-16">
      <p className="text-grey-0 text-p2 font-semibold pb-16">
        {t`checkin.injection-count.input.field-label`}
      </p>
      <InjectionCountDropdown value={selected} onChange={onSelectedChange} />
    </div>

    <div className="w-full fixed max-w-[535px] bottom-16 px-16 left-0 right-0 mx-auto">
      <Button.Primary
        className="w-full font-semibold"
        isDisabled={selected === null}
        onClick={onSubmit}
        label={t`checkin.injection-count.cta.validate`}
      />
    </div>
  </div>
);
